var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Portal',{attrs:{"to":"page-header"}},[_c('PageHeaderNavigator',{attrs:{"navigation-items":_vm.navigationItems}})],1),_c('div',{staticClass:"pt-4"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }